import { BRAND_SLOTS, IMAGES } from "@/data/content";
import { Eyebrow, MaskedLines, Reveal } from "./shared";

// Brand slots are intentional placeholders — replace label + image with
// real brand information when it is supplied by the company.

export default function Brands() {
  return (
    <section
      id="brands"
      data-testid="brands-section"
      className="bg-softblue/60 py-28 md:py-36"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <Eyebrow>Our Brands</Eyebrow>
            <h2 className="mt-7 font-serif font-medium leading-[1.0] tracking-tight text-navy">
              <MaskedLines
                lines={[
                  <span key="a" style={{ fontSize: "clamp(2.6rem, 5.6vw, 5.4rem)" }} className="block">
                    OUR BRANDS<span className="text-brand">.</span>
                  </span>,
                  <span
                    key="b"
                    style={{ fontSize: "clamp(1.7rem, 3vw, 2.8rem)" }}
                    className="mt-3 block font-normal italic text-ink/80"
                  >
                    A growing portfolio, curated with care.
                  </span>,
                ]}
              />
            </h2>
          </div>
          <div className="lg:col-span-4">
            <Reveal delay={0.2}>
              <p className="max-w-sm text-base leading-relaxed text-fog">
                A growing portfolio of beauty, personal care, skincare and baby
                care products.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 grid gap-6 md:grid-cols-3">
          {BRAND_SLOTS.map((slot, i) => (
            <Reveal key={slot.n} delay={i * 0.12} y={40}>
              <div
                className="group border border-brand/10 bg-white"
                data-testid={`brand-slot-${slot.n}`}
              >
                <div className="img-grade relative aspect-[4/3] overflow-hidden">
                  <img
                    src={IMAGES[slot.image]}
                    alt={`${slot.label} — cosmetic product placeholder visual`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
                  />
                </div>
                <div className="flex items-baseline justify-between border-t border-brand/10 px-7 py-6">
                  <span className="font-serif text-2xl font-semibold tracking-[0.1em] text-navy transition-colors duration-500 group-hover:text-brand">
                    {slot.label.toUpperCase()}
                  </span>
                  <span className="text-[10px] font-semibold uppercase tracking-[0.26em] text-fog/70">
                    Details coming soon
                  </span>
                </div>
                <span
                  aria-hidden="true"
                  className="block h-[2px] w-full origin-left scale-x-0 bg-brand transition-transform duration-500 group-hover:scale-x-100"
                />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-8">
          <p className="text-[11px] uppercase tracking-[0.28em] text-fog/70">
            Brand identities will be revealed as the portfolio launches
          </p>
        </Reveal>
      </div>
    </section>
  );
}
